export class TipologicaDTO {
	codice: string;
	descrizione: string;
	id: string;
	codiceLingua: string;
}